import { defineAsyncComponent } from 'vue';
import type { ModularBlockConfig } from '../../../frontend/types';
import { blockImageFields } from './groq';

/** Shared registry entry. Lazy: not on the critical rendering path. */
export const imageBlockConfig = {
  name: 'inner-block-image',
  component: defineAsyncComponent(() => import('./CmsImageBlock.vue')),
  innerComponent: defineAsyncComponent(() => import('./ImageBlock.vue')),
  fields: blockImageFields,
} satisfies ModularBlockConfig;
